var LocalStorageStrategy = /** @class */ (function () {
    function LocalStorageStrategy() {
    }
    LocalStorageStrategy.prototype.isAvailable = function () {
        try {
            var test_1 = '__storage_test__';
            window.localStorage.setItem(test_1, test_1);
            window.localStorage.removeItem(test_1);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    LocalStorageStrategy.prototype.getName = function () {
        return 'localStorage';
    };
    LocalStorageStrategy.prototype.setItem = function (key, value) {
        window.localStorage.setItem(key, value);
    };
    LocalStorageStrategy.prototype.getItem = function (key) {
        return window.localStorage.getItem(key);
    };
    LocalStorageStrategy.prototype.removeItem = function (key) {
        window.localStorage.removeItem(key);
    };
    LocalStorageStrategy.prototype.clear = function () {
        window.localStorage.clear();
    };
    LocalStorageStrategy.prototype.hasItem = function (key) {
        return window.localStorage.getItem(key) !== null;
    };
    return LocalStorageStrategy;
}());
export { LocalStorageStrategy };
var SessionStorageStrategy = /** @class */ (function () {
    function SessionStorageStrategy() {
    }
    SessionStorageStrategy.prototype.isAvailable = function () {
        try {
            var test_2 = '__storage_test__';
            window.sessionStorage.setItem(test_2, test_2);
            window.sessionStorage.removeItem(test_2);
            return true;
        }
        catch (e) {
            return false;
        }
    };
    SessionStorageStrategy.prototype.getName = function () {
        return 'sessionStorage';
    };
    SessionStorageStrategy.prototype.setItem = function (key, value) {
        window.sessionStorage.setItem(key, value);
    };
    SessionStorageStrategy.prototype.getItem = function (key) {
        return window.sessionStorage.getItem(key);
    };
    SessionStorageStrategy.prototype.removeItem = function (key) {
        window.sessionStorage.removeItem(key);
    };
    SessionStorageStrategy.prototype.clear = function () {
        window.sessionStorage.clear();
    };
    SessionStorageStrategy.prototype.hasItem = function (key) {
        return window.sessionStorage.getItem(key) !== null;
    };
    return SessionStorageStrategy;
}());
export { SessionStorageStrategy };
var InMemoryStorage = /** @class */ (function () {
    function InMemoryStorage() {
        this.storage = {};
    }
    InMemoryStorage.prototype.isAvailable = function () {
        return true; // InMemoryStorage is always available
    };
    InMemoryStorage.prototype.getName = function () {
        return 'inMemoryStorage';
    };
    InMemoryStorage.prototype.setItem = function (key, value) {
        this.storage[key] = value;
    };
    InMemoryStorage.prototype.getItem = function (key) {
        return this.storage[key];
    };
    InMemoryStorage.prototype.removeItem = function (key) {
        delete this.storage[key];
    };
    InMemoryStorage.prototype.clear = function () {
        this.storage = {};
    };
    InMemoryStorage.prototype.hasItem = function (key) {
        return this.storage[key] !== undefined;
    };
    return InMemoryStorage;
}());
export { InMemoryStorage };
